import { compile } from 'app/infrastructure/js/template';
import { AppSetting } from 'dependencies/appsettings';

const linkUrl = 'sler://server=${server}&template=${template}&searchId=${searchId}&reportId=${reportId}';
const reportId = 281;

export const caseViewTemplate = 'CaseView';
export const actionViewTemplate = 'ActionView';

export const urlToExcel = (favouriteId: number, template: string) => {

  const serverUrl = AppSetting.ApiBaseUrl;

  const context = {
    server: serverUrl.substr(0, serverUrl.lastIndexOf('/api')),
    searchId: favouriteId,
    template,
    reportId
  };
  return compile(linkUrl, context, encodeURIComponent);
};
